/**
 * Status Bar (STEP 5) — a thin footer strip, the enterprise-desktop-
 * app convention (Epic/Cerner both have one) for always-visible,
 * low-priority status: current tenant/environment, online/offline,
 * app version. Real values only — `env.VITE_ENVIRONMENT` and
 * `navigator.onLine`, nothing fabricated.
 */
import type { JSX } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useOnlineStatus } from '@hooks/useOnlineStatus';
import { useAuthStore } from '@store/auth.store';
import { env } from '@core/config/env';

export function StatusBar(): JSX.Element {
  const isOnline = useOnlineStatus();
  const tenantId = useAuthStore((state) => state.tenantId);

  return (
    <Box
      component="footer"
      sx={{
        height: 28,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" width="100%">
        <Typography variant="caption" color="text.secondary">
          {env.VITE_ENVIRONMENT}
        </Typography>
        {tenantId && (
          <Typography variant="caption" color="text.secondary">
            Tenant: {tenantId.slice(0, 8)}
          </Typography>
        )}
        <Box flexGrow={1} />
        <Typography variant="caption" color={isOnline ? 'success.main' : 'error.main'}>
          {isOnline ? 'Online' : 'Offline'}
        </Typography>
      </Stack>
    </Box>
  );
}
